import { render, staticRenderFns } from "./BusinessRequirementAction.vue?vue&type=template&id=8abdb962"
import script from "./BusinessRequirementAction.vue?vue&type=script&lang=js"
export * from "./BusinessRequirementAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports